// /*!

// =========================================================
// * Vision UI Free React - v1.0.0
// =========================================================

// * Product Page: https://www.creative-tim.com/product/vision-ui-free-react
// * Copyright 2021 Creative Tim (https://www.creative-tim.com/)
// * Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

// * Design and Coded by Simmmple & Creative Tim

// =========================================================

// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

// */

// import { useState, useEffect } from "react";
// import { useLocation, Link } from "react-router-dom";
// import PropTypes from "prop-types";
// import AppBar from "@mui/material/AppBar";
// import Toolbar from "@mui/material/Toolbar";
// import IconButton from "@mui/material/IconButton";
// import Menu from "@mui/material/Menu";
// import Icon from "@mui/material/Icon";
// import VuiBox from "components/VuiBox";
// import VuiTypography from "components/VuiTypography";
// import VuiInput from "components/VuiInput";
// import Breadcrumbs from "examples/Breadcrumbs";
// import NotificationItem from "examples/Items/NotificationItem";

// // Custom styles for DashboardNavbar
// import {
//   navbar,
//   navbarContainer,
//   navbarRow,
//   navbarIconButton,
//   navbarMobileMenu,
// } from "examples/Navbars/DashboardNavbar/styles";
// import {
//   useVisionUIController,
//   setTransparentNavbar,
//   setMiniSidenav,
//   setOpenConfigurator,
// } from "context";
// import team2 from "assets/images/team-2.jpg";
// import logoSpotify from "assets/images/small-logos/logo-spotify.svg";
// import useCommon from "hooks/useCommon";
// import {
//   Button,
//   CircularProgress,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
// } from "@mui/material";
// import VuiButton from "components/VuiButton";
// import { logoutUser } from "store/slice/userSlice";

// function DashboardNavbar({ absolute, light, isMini }) {
//   const { STORE, DISPATCH, NAVIGATE } = useCommon();

//   // const [navbarType, setNavbarType] = useState();
//   const [controller, dispatch] = useVisionUIController();
//   const { miniSidenav, transparentNavbar, fixedNavbar, openConfigurator } = controller;
//   const [openMenu, setOpenMenu] = useState(false);
//   const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

//   // const route = useLocation().pathname.split("/").slice(1);
//   const location = useLocation();

//   const rawRoute = location.pathname.split("/").slice(1);

//   // Remove last segment if it's an ID
//   const route = rawRoute.length > 2 ? rawRoute.slice(0, -1) : rawRoute;

//   const { isAuthenticated, user, logoutLoading } = STORE((state) => state.user);
//   const currentUser = user?.user || user;

//   const displayName = currentUser?.name || currentUser?.email || "Not logged in";

//   const navbarType = fixedNavbar ? "sticky" : "static";

//   useEffect(() => {
//     // Setting the navbar type
//     // if (fixedNavbar) {
//     //   setNavbarType("sticky");
//     // } else {
//     //   setNavbarType("static");
//     // }
//     // A function that sets the transparent state of the navbar.
//     function handleTransparentNavbar() {
//       setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
//     }
//     /**
//      The event listener that's calling the handleTransparentNavbar function when
//      scrolling the window.
//     */
//     window.addEventListener("scroll", handleTransparentNavbar);
//     // Call the handleTransparentNavbar function to set the state with the initial value.
//     handleTransparentNavbar();
//     // Remove event listener on cleanup
//     return () => window.removeEventListener("scroll", handleTransparentNavbar);
//   }, [dispatch, fixedNavbar]);

//   const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
//   const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);
//   const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
//   const handleCloseMenu = () => setOpenMenu(false);
//   const handleOpenLogoutDialog = () => setLogoutDialogOpen(true);
//   const handleCloseLogoutDialog = () => setLogoutDialogOpen(false);

//   const handleConfirmLogout = () => {
//     setLogoutDialogOpen(false);
//     DISPATCH(logoutUser());
//     // NAVIGATE("/authentication/sign-in", { replace: true });
//     // window.location.reload();
//   };

//   // Render the notifications menu
//   const renderMenu = () => (
//     <Menu
//       anchorEl={openMenu}
//       anchorReference={null}
//       anchorOrigin={{
//         vertical: "bottom",
//         horizontal: "left",
//       }}
//       open={Boolean(openMenu)}
//       onClose={handleCloseMenu}
//       sx={{ mt: 2 }}
//     >
//       <NotificationItem
//         image={<img src={team2} alt="person" />}
//         title={["New message", "from Laur"]}
//         date="13 minutes ago"
//         onClick={handleCloseMenu}
//       />
//       <NotificationItem
//         image={<img src={logoSpotify} alt="person" />}
//         title={["New album", "by Travis Scott"]}
//         date="1 day"
//         onClick={handleCloseMenu}
//       />
//       <NotificationItem
//         image={
//           <Icon fontSize="small" sx={{ color: ({ palette: { white } }) => white.main }}>
//             payment
//           </Icon>
//         }
//         title={["", "Payment successfully completed"]}
//         date="2 days"
//         onClick={handleCloseMenu}
//       />
//     </Menu>
//   );

//   return (
//     <>
//       <AppBar
//         position={absolute ? "absolute" : navbarType}
//         color="inherit"
//         sx={(theme) => navbar(theme, { transparentNavbar, absolute, light })}
//       >
//         <Toolbar sx={(theme) => navbarContainer(theme)}>
//           <VuiBox
//             color="inherit"
//             mb={{ xs: 0, md: 0 }}
//             sx={(theme) => ({
//               ...navbarRow(theme, { isMini }),
//               flex: 1, //  allow shrink
//               minWidth: 0, // for wrapping
//             })}
//           >
//             <Breadcrumbs icon="home" title={route[route.length - 1]} route={route} light={light} />
//           </VuiBox>
//           {isMini ? null : (
//             <VuiBox sx={(theme) => navbarRow(theme, { isMini, light })}>
//               {/* <VuiBox pr={1}>
//               <VuiInput
//                 placeholder="Type here..."
//                 icon={{ component: "search", direction: "left" }}
//                 sx={({ breakpoints }) => ({
//                   [breakpoints.down("sm")]: {
//                     maxWidth: "80px",
//                   },
//                   [breakpoints.only("sm")]: {
//                     maxWidth: "80px",
//                   },
//                   backgroundColor: "info.main !important",
//                 })}
//               />
//             </VuiBox> */}
//               <VuiBox color={light ? "white" : "inherit"}>
//                 <Link to="/profile">
//                   <IconButton sx={(theme) => navbarIconButton(theme, { light })} size="small">
//                     <Icon
//                       sx={({ palette: { dark, white } }) => ({
//                         color: light ? white.main : dark.main,
//                       })}
//                     >
//                       account_circle
//                     </Icon>
//                     <VuiTypography
//                       variant="button"
//                       fontWeight="medium"
//                       color={light ? "white" : "dark"}
//                     >
//                       {displayName || "Not logged in"}
//                     </VuiTypography>
//                   </IconButton>
//                 </Link>
//                 <IconButton
//                   size="small"
//                   color="inherit"
//                   sx={(theme) => navbarMobileMenu(theme, { light })}
//                   onClick={handleMiniSidenav}
//                 >
//                   <Icon className={"text-white"}>{miniSidenav ? "menu_open" : "menu"}</Icon>
//                 </IconButton>
//                 <IconButton
//                   size="small"
//                   color="inherit"
//                   sx={(theme) => navbarIconButton(theme, { light })}
//                   onClick={handleConfiguratorOpen}
//                 >
//                   <Icon>settings</Icon>
//                 </IconButton>
//                 <IconButton
//                   size="small"
//                   color="error"
//                   sx={(theme) => navbarIconButton(theme, { light })}
//                   aria-controls="notification-menu"
//                   aria-haspopup="true"
//                   variant="contained"
//                   onClick={handleOpenLogoutDialog}
//                 >
//                   <Icon className="text-error">logout</Icon>
//                 </IconButton>
//                 {renderMenu()}
//               </VuiBox>
//             </VuiBox>
//           )}
//         </Toolbar>
//       </AppBar>

//       <Dialog
//         open={logoutDialogOpen}
//         onClose={(event, reason) => {
//           if (reason === "backdropClick" || reason === "escapeKeyDown") return;
//           if (logoutLoading) return;
//           handleCloseLogoutDialog();
//         }}
//         aria-labelledby="logout-dialog-title"
//         sx={{
//           "& .MuiDialog-paper": {
//             p: 1,
//             borderRadius: "14px",
//             background: "linear-gradient(135deg, rgba(255,255,255,0.10), rgba(255,255,255,0.05))",
//             backdropFilter: "blur(20px)",
//             WebkitBackdropFilter: "blur(20px)",
//             border: "1px solid rgba(255, 255, 255, 0.2)",
//             // borderRadius: borders.borderRadius.lg,
//             boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.25)",
//           },
//         }}
//       >
//         {/* <DialogTitle id="logout-dialog-title">Log out?</DialogTitle> */}
//         <DialogContent p={5}>
//           <VuiTypography variant="body2">
//             Are you sure you want to logout of your account?
//           </VuiTypography>
//         </DialogContent>
//         <DialogActions>
//           <VuiButton
//             variant="outlined"
//             color="primary"
//             onClick={handleCloseLogoutDialog}
//             disabled={logoutLoading}
//           >
//             Cancel
//           </VuiButton>
//           <VuiButton
//             color="error"
//             onClick={handleConfirmLogout}
//             disabled={logoutLoading}
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: 1,
//               minWidth: "120px",
//             }}
//           >
//             {logoutLoading && <CircularProgress size={16} thickness={5} sx={{ color: "white" }} />}

//             {logoutLoading ? "Logging out..." : "Logout"}
//           </VuiButton>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// }

// // Setting default values for the props of DashboardNavbar
// DashboardNavbar.defaultProps = {
//   absolute: false,
//   light: false,
//   isMini: false,
// };

// // Typechecking props for the DashboardNavbar
// DashboardNavbar.propTypes = {
//   absolute: PropTypes.bool,
//   light: PropTypes.bool,
//   isMini: PropTypes.bool,
// };

// export default DashboardNavbar;

/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

*/

import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import PropTypes from "prop-types";

import {
  AppBar,
  Badge,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Icon,
  IconButton,
  Menu,
  Toolbar,
} from "@mui/material";

import { FaBell, FaCheck } from "react-icons/fa";

import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";

import Breadcrumbs from "examples/Breadcrumbs";

import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarMobileMenu,
} from "examples/Navbars/DashboardNavbar/styles";

import {
  useVisionUIController,
  setTransparentNavbar,
  setMiniSidenav,
  setOpenConfigurator,
} from "context";

import useCommon from "hooks/useCommon";

import { logoutUser } from "store/slice/userSlice";

import {
  getHousekeepingNotifications,
  markHousekeepingNotificationsRead,
  markNotificationReadLocally,
  resetMarkReadState,
} from "store/slice/pusherSlice";

import colors from "assets/theme/base/colors";
import rgba from "assets/theme/functions/rgba";
import { triggerHousekeepingRoomsRefresh } from "store/slice/pusherSlice";

const { dark, primary, success, info, light: lightColor } = colors;

const formatNotificationDate = (date) => {
  if (!date) return "";

  const notificationDate = new Date(date);

  if (Number.isNaN(notificationDate.getTime())) {
    return "";
  }

  const now = new Date();

  const diffMs = now.getTime() - notificationDate.getTime();

  const diffMinutes = Math.floor(diffMs / 60000);

  const diffHours = Math.floor(diffMs / 3600000);

  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMinutes < 1) {
    return "Just now";
  }

  if (diffMinutes < 60) {
    return `${diffMinutes}m ago`;
  }

  if (diffHours < 24) {
    return `${diffHours}h ago`;
  }

  if (diffDays < 7) {
    return `${diffDays}d ago`;
  }

  return notificationDate.toLocaleDateString();
};

function DashboardNavbar({ absolute, light, isMini }) {
  const { STORE, DISPATCH } = useCommon();

  const [controller, dispatch] = useVisionUIController();

  const { miniSidenav, transparentNavbar, fixedNavbar, openConfigurator } = controller;

  const [openMenu, setOpenMenu] = useState(null);

  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

  const location = useLocation();

  const rawRoute = location.pathname.split("/").slice(1);

  const route = rawRoute.length > 2 ? rawRoute.slice(0, -1) : rawRoute;

  const { user, logoutLoading } = STORE((state) => state.user);

  const {
    notifications,
    notificationsLoading,
    notificationsError,
    unreadCount,

    markReadLoading,
    markReadError,
  } = STORE((state) => state.pusher);

  const currentUser = user?.user || user;

  const displayName = currentUser?.name || currentUser?.email || "Not logged in";

  const navbarType = fixedNavbar ? "sticky" : "static";

  useEffect(() => {
    function handleTransparentNavbar() {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    window.addEventListener("scroll", handleTransparentNavbar);

    handleTransparentNavbar();

    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);

  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  const handleOpenMenu = (event) => {
    setOpenMenu(event.currentTarget);

    DISPATCH(resetMarkReadState());

    DISPATCH(
      getHousekeepingNotifications({
        page: 1,
        pageSize: 20,
        unreadOnly: false,
      })
    );
  };

  const handleCloseMenu = () => {
    setOpenMenu(null);

    DISPATCH(resetMarkReadState());
  };

  const handleOpenLogoutDialog = () => setLogoutDialogOpen(true);

  const handleCloseLogoutDialog = () => setLogoutDialogOpen(false);

  const handleConfirmLogout = () => {
    setLogoutDialogOpen(false);

    DISPATCH(logoutUser());
  };

  const handleNotificationClick = async (notification) => {
    if (!notification?._id || notification?.isRead) {
      return;
    }

    DISPATCH(markNotificationReadLocally(notification._id));

    try {
      await DISPATCH(markHousekeepingNotificationsRead([notification._id])).unwrap();

      DISPATCH(triggerHousekeepingRoomsRefresh());
    } catch (error) {
      console.log("Failed to mark notification as read:", error);
    }
  };

  const handleMarkAllRead = async () => {
    if (!unreadCount || markReadLoading) {
      return;
    }

    try {
      await DISPATCH(markHousekeepingNotificationsRead()).unwrap();

      DISPATCH(triggerHousekeepingRoomsRefresh());
    } catch (error) {}
  };

  const renderNotificationMenu = () => (
    <Menu
      id="notification-menu"
      anchorEl={openMenu}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      PaperProps={{
        sx: {
          mt: 1.5,
          width: 360,
          maxWidth: "calc(100vw - 24px)",
          maxHeight: 480,

          borderRadius: "14px",

          background: lightColor.main,

          border: "1px solid rgba(0,0,0,0.08)",

          boxShadow: "0 12px 35px rgba(0,0,0,0.18)",

          overflow: "hidden",

          "& .MuiList-root": {
            p: 0,
          },
        },
      }}
    >
      {/* Header */}
      <VuiBox
        px={2}
        py={1.5}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        gap={1}
        sx={{
          background: lightColor.main,
        }}
      >
        <VuiBox>
          <VuiTypography variant="button" fontWeight="medium" color="dark">
            Notifications
          </VuiTypography>

          <VuiTypography
            variant="caption"
            color="dark"
            sx={{
              display: "block",
              opacity: 0.55,
              mt: 0.2,
            }}
          >
            {unreadCount > 0 ? `${unreadCount} unread` : "You're all caught up"}
          </VuiTypography>
        </VuiBox>

        {unreadCount > 0 && (
          <VuiButton
            variant="text"
            color="primary"
            size="small"
            disabled={markReadLoading}
            onClick={handleMarkAllRead}
            sx={{
              minWidth: "auto",
              px: 1,
            }}
          >
            {markReadLoading ? "Marking..." : "Mark all read"}
          </VuiButton>
        )}
      </VuiBox>

      {/* Loading */}
      {notificationsLoading && (
        <VuiBox
          py={5}
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          gap={1}
          sx={{
            background: lightColor.main,
          }}
        >
          <CircularProgress size={24} />

          <VuiTypography
            variant="caption"
            color="dark"
            sx={{
              opacity: 0.55,
            }}
          >
            Loading notifications...
          </VuiTypography>
        </VuiBox>
      )}

      {/* Fetch Error */}
      {!notificationsLoading && notificationsError && (
        <VuiBox
          mx={2}
          my={2}
          p={1.2}
          borderRadius="md"
          sx={{
            border: "1px solid rgba(239,68,68,0.4)",
            background: "rgba(239,68,68,0.08)",
          }}
        >
          <VuiTypography variant="caption" color="error">
            {typeof notificationsError === "string"
              ? notificationsError
              : notificationsError?.message || "Failed to load notifications"}
          </VuiTypography>
        </VuiBox>
      )}

      {/* Mark Read Error */}
      {markReadError && (
        <VuiBox
          mx={2}
          my={1}
          p={1.2}
          borderRadius="md"
          sx={{
            border: "1px solid rgba(239,68,68,0.4)",
            background: "rgba(239,68,68,0.08)",
          }}
        >
          <VuiTypography variant="caption" color="error">
            {typeof markReadError === "string"
              ? markReadError
              : markReadError?.message || "Failed to update notifications"}
          </VuiTypography>
        </VuiBox>
      )}

      {/* Empty */}
      {!notificationsLoading && !notificationsError && notifications?.length === 0 && (
        <VuiBox
          py={5}
          px={2}
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          gap={1}
          sx={{
            background: lightColor.main,
          }}
        >
          <VuiBox
            width={42}
            height={42}
            display="flex"
            alignItems="center"
            justifyContent="center"
            borderRadius="50%"
            sx={{
              background: rgba(info.main, 0.1),

              border: `1px solid ${rgba(info.main, 0.18)}`,
            }}
          >
            <FaBell size={15} color={info.main} />
          </VuiBox>

          <VuiTypography
            variant="caption"
            color="dark"
            sx={{
              opacity: 0.55,
            }}
          >
            No notifications yet
          </VuiTypography>
        </VuiBox>
      )}

      {/* Notification List */}
      {!notificationsLoading && notifications?.length > 0 && (
        <VuiBox
          sx={{
            maxHeight: 380,
            overflowY: "auto",

            background: lightColor.main,
          }}
        >
          {notifications.map((notification) => {
            const message = notification?.payload?.message || "Housekeeping update";

            return (
              <VuiBox
                key={notification._id}
                px={2}
                py={1.4}
                display="flex"
                alignItems="flex-start"
                gap={1.2}
                onClick={() => handleNotificationClick(notification)}
                sx={{
                  cursor: notification.isRead ? "default" : "pointer",

                  background: notification.isRead ? lightColor.main : rgba(success.main, 0.055),

                  borderBottom: "1px solid rgba(0,0,0,0.06)",

                  transition: "background 0.2s ease",

                  "&:hover": {
                    background: notification.isRead
                      ? "rgba(0,0,0,0.035)"
                      : rgba(success.main, 0.09),
                  },
                }}
              >
                {/* Icon */}
                <VuiBox
                  width={34}
                  height={34}
                  flexShrink={0}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  borderRadius="10px"
                  sx={{
                    background: rgba(info.main, 0.1),

                    border: `1px solid ${rgba(info.main, 0.18)}`,
                  }}
                >
                  <FaBell size={12} color={info.main} />
                </VuiBox>

                <VuiBox flex={1} minWidth={0}>
                  <VuiTypography
                    variant="caption"
                    color="dark"
                    sx={{
                      display: "block",

                      lineHeight: 1.5,

                      fontWeight: notification.isRead ? 400 : 500,
                    }}
                  >
                    {message}
                  </VuiTypography>

                  <VuiTypography
                    variant="caption"
                    color="dark"
                    sx={{
                      display: "block",

                      mt: 0.45,

                      opacity: 0.45,
                    }}
                  >
                    {formatNotificationDate(notification.createdAt)}
                  </VuiTypography>
                </VuiBox>

                {/* Unread marker */}
                {!notification.isRead && (
                  <VuiBox
                    width={7}
                    height={7}
                    borderRadius="50%"
                    flexShrink={0}
                    mt={0.8}
                    sx={{
                      background: success.main,

                      boxShadow: `0 0 0 3px ${rgba(success.main, 0.12)}`,
                    }}
                  />
                )}

                {notification.isRead && (
                  <FaCheck
                    size={9}
                    color={rgba(dark.main, 0.35)}
                    style={{
                      marginTop: 5,
                      flexShrink: 0,
                    }}
                  />
                )}
              </VuiBox>
            );
          })}
        </VuiBox>
      )}
    </Menu>
  );

  return (
    <>
      <AppBar
        position={absolute ? "absolute" : navbarType}
        color="inherit"
        sx={(theme) =>
          navbar(theme, {
            transparentNavbar,
            absolute,
            light,
          })
        }
      >
        <Toolbar sx={(theme) => navbarContainer(theme)}>
          <VuiBox
            color="inherit"
            mb={{
              xs: 0,
              md: 0,
            }}
            sx={(theme) => ({
              ...navbarRow(theme, {
                isMini,
              }),
              flex: 1,
              minWidth: 0,
            })}
          >
            <Breadcrumbs icon="home" title={route[route.length - 1]} route={route} light={light} />
          </VuiBox>

          {isMini ? null : (
            <VuiBox
              sx={(theme) =>
                navbarRow(theme, {
                  isMini,
                  light,
                })
              }
            >
              <VuiBox color={light ? "white" : "inherit"}>
                {/* Profile */}
                <Link to="/profile">
                  <IconButton
                    sx={(theme) =>
                      navbarIconButton(theme, {
                        light,
                      })
                    }
                    size="small"
                  >
                    <Icon
                      sx={({ palette: { dark, white } }) => ({
                        color: light ? white.main : dark.main,
                      })}
                    >
                      account_circle
                    </Icon>

                    <VuiTypography
                      variant="button"
                      fontWeight="medium"
                      color={light ? "white" : "dark"}
                    >
                      {displayName}
                    </VuiTypography>
                  </IconButton>
                </Link>

                {/* Mobile menu */}
                <IconButton
                  size="small"
                  color="inherit"
                  sx={(theme) =>
                    navbarMobileMenu(theme, {
                      light,
                    })
                  }
                  onClick={handleMiniSidenav}
                >
                  <Icon className="text-white">{miniSidenav ? "menu_open" : "menu"}</Icon>
                </IconButton>

                {/* Notifications */}
                <IconButton
                  size="small"
                  color="inherit"
                  sx={(theme) =>
                    navbarIconButton(theme, {
                      light,
                    })
                  }
                  aria-controls={"notification-menu"}
                  aria-haspopup="true"
                  onClick={handleOpenMenu}
                >
                  <Badge
                    badgeContent={unreadCount}
                    color="error"
                    max={99}
                    overlap="circular"
                    sx={{
                      "& .MuiBadge-badge": {
                        fontSize: "9px",
                        minWidth: "16px",
                        height: "16px",
                        padding: "0 4px",
                      },
                    }}
                  >
                    <FaBell size={14} />
                  </Badge>
                </IconButton>

                {/* Settings */}
                <IconButton
                  size="small"
                  color="inherit"
                  sx={(theme) =>
                    navbarIconButton(theme, {
                      light,
                    })
                  }
                  onClick={handleConfiguratorOpen}
                >
                  <Icon>settings</Icon>
                </IconButton>

                {/* Logout */}
                <IconButton
                  size="small"
                  color="error"
                  sx={(theme) =>
                    navbarIconButton(theme, {
                      light,
                    })
                  }
                  onClick={handleOpenLogoutDialog}
                >
                  <Icon className="text-error">logout</Icon>
                </IconButton>

                {renderNotificationMenu()}
              </VuiBox>
            </VuiBox>
          )}
        </Toolbar>
      </AppBar>

      {/* Logout Dialog */}
      <Dialog
        open={logoutDialogOpen}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
          }

          if (logoutLoading) {
            return;
          }

          handleCloseLogoutDialog();
        }}
        aria-labelledby="logout-dialog-title"
        sx={{
          "& .MuiDialog-paper": {
            p: 1,
            borderRadius: "14px",
            background: "linear-gradient(135deg, rgba(255,255,255,0.10), rgba(255,255,255,0.05))",
            backdropFilter: "blur(20px)",
            WebkitBackdropFilter: "blur(20px)",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.25)",
          },
        }}
      >
        <DialogContent p={5}>
          <VuiTypography variant="body2">
            Are you sure you want to logout of your account?
          </VuiTypography>
        </DialogContent>

        <DialogActions>
          <VuiButton
            variant="outlined"
            color="primary"
            onClick={handleCloseLogoutDialog}
            disabled={logoutLoading}
          >
            Cancel
          </VuiButton>

          <VuiButton
            color="error"
            onClick={handleConfirmLogout}
            disabled={logoutLoading}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              minWidth: "120px",
            }}
          >
            {logoutLoading && (
              <CircularProgress
                size={16}
                thickness={5}
                sx={{
                  color: "white",
                }}
              />
            )}

            {logoutLoading ? "Logging out..." : "Logout"}
          </VuiButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
